import { isNumber } from '@lifk/utils'
import { ZodError } from 'zod'

// For use with array validations (see useGetRemedies.ts for an example)
// Filters out items that fail validation
export const removeInvalidItems = <T extends object>(
  originalList: (T | undefined)[],
  validationError: ZodError,
  disableValidations: boolean
): T[] => {
  if (disableValidations) {
    // only filter out undefined
    return originalList.filter((val) => !!val)
  }

  console.warn('Some items are invalid. Filtering out...')
  console.debug('Validation error: ', validationError.issues)

  const invalidIndexes: number[] = validationError.issues
    .map((issue) => issue?.path?.[0])
    .filter((indexOrNull) => isNumber(indexOrNull)) as number[]
  const uniqueIndexes = new Set(invalidIndexes)

  return originalList.filter((item, i): item is T => {
    const isValid = !!item && !uniqueIndexes.has(i)
    if (!isValid) {
      console.debug('Invalid item: ', item)
    }
    return isValid
  })
}
